<template>
  <div class="full-container">
    <div class="new-detail container">
      <div class="wrapper">
        <div class="title">{{ articleData.title }}</div>
        <div class="info">
          <div class="time">{{ articleData.time }}</div>
        </div>
        <hr />
        <div class="content" v-html="articleData.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQueryObject } from "@/utils";
import newDate from "../news";
export default {
  // name: "article",
  data() {
    return {
      articleId: "",
      articleData: {
        title: "热烈欢迎陕西鼓风机集团和中石化工程建设公司贵宾到访APJ",
        time: "2019-12-15",
        content:
          "在为期两天的参观交流期间，双方围绕互联网+教育、智能制造工厂、企业数字化转型升级等主题展开了一系列的交流和讨论，共同探讨双方在未来开展多领域、全方位深度合作的方向和机会。",
      },
    };
  },
  watch: {
    articleId(val) {
      this.loadData();
    },
  },
  mounted() {},
  created() {
    this.load();
  },
  methods: {
    load() {
      let param = getQueryObject();
      console.log("load ... ", param);
      if (!param.id) {
        this.toNews();
        return;
      }
      this.articleId = param.id;
    },
    toNews() {},
    loadData(articleId) {
      articleId = articleId || this.articleId;
      console.log("loadData(articleId) ... ", articleId,newDate);
      let data = newDate.filter((value) => {
        return value.id == articleId;
      });
      if (data && data.length == 1) {
        this.articleData = data[0];
      }
    },
  },
};
</script>


</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/theme.scss";

div {
  width: 100%;
}

/** page style */
.new-detail {
  min-height: 800px;
  padding-top: 40px;

  > .wrapper {
    // border: 1px solid #e5e5e5;
    // padding-top: 40px;
  }
  hr {
    border-top-width: 0;
  }
  .title {
    font-size: 24px;
    min-height: 30px;
    line-height: 30px;
    font-weight: bold;
    color: #333;
    // color: $color-text-primary;
    text-align: center;
  }
  .info {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    margin-top: 15px;
    color: #999999;
    text-align: center;

    > div {
      font-size: 14px;
      color: #999999;
    }
  }
  .content {
    font-size: 16px;
    margin-top: 40px;
    width: 100%;
    overflow: hidden;
    height: auto;
    padding-bottom: 60px;
    line-height: 2;
    text-align: left;

    ::v-deep .ql-align-center {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutus/news/detail/index.vue